"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClient = typeof window === 'object';
exports.on = function (obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  return obj.addEventListener.apply(obj, args);
};
exports.off = function (obj) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  return obj.removeEventListener.apply(obj, args);
};